import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import WysiwygEditor from "../../../../SharedComponents/WysiwygEditor";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { addRange, resetWysiwyg, updateRangeState } from "../Store";
import Button from "react-bootstrap/Button";
import RangeList from "./RangeList/RangeList";
import IconSvg from "../../../../SharedComponents/IconSvg";
import { isValidScale } from "../Utils";
import { setRgbColor } from "../Store";
import { useState } from "react";

export default function ScaleForm({ onChange }) {
  const dispatch = useDispatch();
  const range = useSelector((state) => state.scale.range);
  const isHtml = useSelector((state) => state.scale.isHtml);
  const ranges = useSelector((state) => state.scale.ranges);
  const isDual = useSelector((state) => state.scale.isDual);
  const rgbColor = useSelector((state) => state.scale.rgbColor);

  // Local state for color checkbox
  const [enableCustomColor, setEnableCustomColor] = useState(rgbColor !== "no-color");

  const add = () => {
    dispatch(
      addRange({
        text: range.text,
        rightText: range.rightText,
        start: parseInt(range.start, 10),
        end: parseInt(range.end, 10),
        rgbColor: enableCustomColor ? rgbColor : "no-color",
      })
    );

    dispatch(resetWysiwyg(true));
  };

  const updateRange = (property, value) => {
    dispatch(
      updateRangeState({
        property,
        value,
      })
    );
    dispatch(resetWysiwyg(false));
  };

  const updateRgbColor = (color) => {
    dispatch(setRgbColor(color));
  };

  const handleColorCheckboxChange = (checked) => {
    setEnableCustomColor(checked);
    if (!checked) {
      dispatch(setRgbColor("no-color"));
    } else {
      dispatch(setRgbColor("#ffffff")); // Default to white when enabling
    }
  };

  // Convert hex color to RGB values
  const hexToRgb = (hex) => {
    if (!hex || hex === "#ffffff" || hex === "#FFFFFF" || hex === "no-color") return "255, 255, 255";

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
      : "255, 255, 255";
  };

  const addAllScales = () => {
    onChange && onChange(ranges);
  };

  const isAllowAdd = () => {
    var isValid = isValidScale(ranges, range);
    if (!isValid || !range.text || (isDual && !range.rightText)) return true;
  };

  return (
    <Row>
      <Row className="mb-3">
        <Col xs="12" md="1" className="mb-3">
          <Form.Check
            type="checkbox"
            id="enable-custom-color"
            label="RGB "
            checked={enableCustomColor}
            onChange={(e) => handleColorCheckboxChange(e.target.checked)}
          />
          <div
            style={{
              fontSize: "0.65rem",
              color: enableCustomColor ? "#666" : "#999",
              textAlign: "center",
            }}
          >
            RGB: {enableCustomColor ? hexToRgb(rgbColor) : "Default CSS"}
          </div>
        </Col>
        {enableCustomColor && (
          <Col xs="6" md="2">
            <InputGroup>
              <InputGroup.Text>
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: enableCustomColor ? rgbColor || "#ffffff" : "#e9ecef",
                    border: "1px solid #ccc",
                    borderRadius: "3px",
                    cursor: enableCustomColor ? "pointer" : "not-allowed",
                    opacity: enableCustomColor ? 1 : 0.5,
                  }}
                  title={enableCustomColor ? "Click to select color" : "Enable custom color first"}
                />
              </InputGroup.Text>
              <Form.Control
                type="color"
                value={enableCustomColor ? rgbColor || "#ffffff" : "#ffffff"}
                onChange={(event) => updateRgbColor(event.target.value)}
                style={{ width: "60px", padding: "1px", border: "none" }}
                title="Select hex color"
                disabled={!enableCustomColor}
              />
            </InputGroup>
          </Col>
        )}

        <Col xs="6" md="2">
          <InputGroup>
            <InputGroup.Text>start</InputGroup.Text>
            <Form.Control
              name="start"
              required
              max="100"
              min="0"
              type="number"
              value={range.start}
              placeholder="start"
              onChange={(event) => updateRange("start", event.target.value)}
            />
          </InputGroup>
        </Col>
        <Col xs="6" md="2">
          <InputGroup>
            <InputGroup.Text>end</InputGroup.Text>
            <Form.Control
              name="end"
              required
              max="100"
              min={range.start}
              type="number"
              // disabled={parseInt(range.start, 10) === 100}
              value={range.end}
              placeholder="end"
              onChange={(event) => updateRange("end", event.target.value)}
            />
          </InputGroup>
        </Col>
        {!isHtml && (
          <Col>
            <Row>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroup.Text></InputGroup.Text>
                  <Form.Control
                    name="description"
                    value={range.text}
                    placeholder="description"
                    onChange={(event) => updateRange("text", event.target.value)}
                  />
                </InputGroup>
              </Col>
              {isDual && (
                <Col>
                  <InputGroup className="mb-3">
                    <InputGroup.Text></InputGroup.Text>
                    <Form.Control
                      name="description"
                      value={range.rightText}
                      placeholder="description"
                      onChange={(event) => updateRange("rightText", event.target.value)}
                    />
                  </InputGroup>
                </Col>
              )}
            </Row>
          </Col>
        )}

        <Col xs={1}>
          <Button style={{ width: "100%" }} disabled={isAllowAdd()} onClick={add}>
            Ekle <IconSvg icon="plus" />
          </Button>
        </Col>
        <RangeList />
      </Row>
      <Row>
        <Col>
          {isHtml && (
            <Row>
              <Col>
                <WysiwygEditor reset={resetWysiwyg} onChange={(html) => updateRange("text", html)} />
              </Col>
              {isDual && (
                <Col>
                  <WysiwygEditor reset={resetWysiwyg} onChange={(html) => updateRange("rightText", html)} />
                </Col>
              )}
            </Row>
          )}
        </Col>
      </Row>
    </Row>
  );
}
